import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes';

import store from './plugin/store'
import Gravatar from 'vue-gravatar';
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBxur5McPrGSDyu7t3J9dcx04BvHd48Y-I',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('v-gravatar', Gravatar);

import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
//const socket = io('http://localhost:3000/admin',{
const socket = io('https://api.cc.itmaster.dk/admin',{
  autoConnect: true,
  query: {
    token: localStorage.token,
  }
});
Vue.use(VueSocketIOExt, socket);

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes
});
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')